/**
 * Payment settings response containing the PSP publishable key and the list of supported
 * payment methods.
 */
export interface PaymentMethodsSettings {
  /**
   * List of available payment methods.
   */
  paymentMethods: PaymentMethod[]
  /**
   * The publishable key from the Payment Service Provider. Present for MOR (Merchant of
   * Record) bookings, null for Assisted bookings.
   */
  pspPublishableKey: null | string
}

/**
 * The payment method.
 */
export interface PaymentMethod {
  /**
   * List of cards. Returns empty when the type of the payment method is not a card.
   */
  cards: Card[]
  /**
   * The type of the payment method.
   */
  type: PaymentMethodType
}

/**
 * The card.
 */
export interface Card {
  /**
   * The card brand name.
   */
  brand: Brand
  /**
   * The card brand code.
   */
  code: Code
  /**
   * ISO country code used in the payment processing for Assisted bookings. This is null when
   * not returned by the provider.
   */
  processorCountryCode: null | string
}

/**
 * The card brand name.
 */
export enum Brand {
  AmericanExpress = 'American Express',
  DinersClub = 'Diners Club',
  Discover = 'Discover',
  Jcb = 'JCB',
  Maestro = 'Maestro',
  Mastercard = 'Mastercard',
  MastercardDebit = 'Mastercard Debit',
  UnionPay = 'Union Pay',
  Visa = 'Visa',
  VisaDebit = 'Visa Debit',
  VisaElectron = 'Visa Electron'
}

/**
 * The card brand code.
 */
export enum Code {
  Ax = 'AX',
  CA = 'CA',
  CD = 'CD',
  Cu = 'CU',
  Dc = 'DC',
  Ds = 'DS',
  E = 'E',
  Jc = 'JC',
  To = 'TO',
  Vd = 'VD',
  Vi = 'VI'
}

/**
 * The type of the payment method.
 */
export enum PaymentMethodType {
  ApplePay = 'apple_pay',
  Card = 'card',
  GooglePay = 'google_pay',
  Ideal = 'ideal',
  Klarna = 'klarna',
  Paypal = 'paypal',
  RevolutPay = 'revolut_pay',
  Vipps = 'vipps'
}
